<template>
    <div class="grid grid-cols-12 gap-6 mt-12">
        <div class="col-span-12 md:col-span-12 xl:col-span-12">
            <base-heading-secondary text="Informations"></base-heading-secondary>

            <base-loading-indicator-box class="mt-6" v-if="commentsLoading">
            </base-loading-indicator-box>
            <div class="rounded pb-1 mt-6" v-else>
                <interruption-comment v-for="comment in comments" :comment="comment" :key="comment.id"></interruption-comment>
            </div>
        </div>

        <rate-limit-exceeded-modal :open="rateLimitExceeded"></rate-limit-exceeded-modal>
    </div>
</template>

<script>
export default {
    props: {
        interruptionId: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            affectedHostsLoading: true,
            affectedHosts: Array,
            commentsLoading: true,
            comments: Object,
            rateLimitExceeded: false,
        }
    },
    methods: {
        handleRateLimit() {
            this.rateLimitExceeded = true;
        },
        fetchComments() {
            this.commentsLoading = true;

            axios.get(route('api.zap.interruption.history', {
                interruption: this.interruptionId
            })).then(function (response) {
                this.comments = response.data.history;

                this.commentsLoading = false;
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.handleRateLimit();
                    }
                }.bind(this))
        },
        refresh() {
            this.rateLimitExceeded = false;

            this.fetchComments();
        },
        detailHostRoute(host) {
            return route('host', {
                hostID: host.id
            });
        },
    },
    mounted() {
        this.$eventHub.$on('refresh', this.refresh);

        setTimeout(function () {
            this.refresh();
        }.bind(this), 1500);
    },
}
</script>
